/**
 * L1 content depth (Soft lock 2026-09-10):
 * L1.0 hero holes → L1.1 +line → L1.2 +board → L1.3 +villains → L1.4 +takeaway
 * Screen/visual order stays Soft #2: line → holes → board (not a reorder of depth).
 * Empty layers: hide — never fabricate placeholders ("—") on human Share/Copy/PNG.
 */
import type { Card, HandState, StreetAction } from "./types"

export function shareHasHeroHoles(
  hole: [Card | null, Card | null],
): boolean {
  return Boolean(hole[0] && hole[1])
}

export function shareHasLine(actions: StreetAction[]): boolean {
  return actions.length > 0
}

export function shareHasBoard(board: HandState["board"]): boolean {
  return board.flop.some(Boolean) || Boolean(board.turn) || Boolean(board.river)
}

export function shareHasVillains(state: HandState): boolean {
  const known = state.knownHoles ?? {}
  return Object.keys(known).some((pos) => {
    if (pos === state.heroPosition) return false
    const h = known[pos]
    return Boolean(h && h[0] && h[1])
  })
}

export function shareHasTakeaway(takeaway: string | undefined): boolean {
  return Boolean(takeaway?.trim())
}
